<p-dialog appendTo="body" [(visible)]="visible" [draggable]="draggable" [modal]="modal" [resizable]="false" [closable]="closable" [contentStyle]="contentStyle" [style]="style">
  <ng-template pTemplate="header">
    @if (titleIconClass) {
      <div style="display: flex; align-items: center; justify-content: center; gap: 8px; width: 100%">
        <span [class]="titleContainerIcon"><i aria-hidden="true" [class]="titleIconClass"></i></span>
        <h2 [class]="titleAdditionalClass" style="margin: 0">{{ title }}</h2>
      </div>
    }
  </ng-template>
  <ng-template pTemplate="content">
    @if (!useCustomContent) {
      <div class="text-center">
        <p>{{ content }}</p>
      </div>
    }
    @if (useCustomContent) {
      <ng-content></ng-content>
    }
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="text-center" [class]="footerAdditionalClass">
      @for (button of buttons; track button) {
        <button [class]="button.buttonClass" [disabled]="button.disabled" type="button" (click)="dialogButtonClick(button.name)">
          @if (button.iconClass) {
            <i aria-hidden="true" [class]="button.iconClass"></i>
          }
          {{ button.label }}
        </button>
      }
    </div>
  </ng-template>
</p-dialog>
